import { useCallback, useRef, useState } from "react";

import useClickOutside from "@verse_core/shared_components/useClickOutside";

export const useDropdown = (closeDelay = 100) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const closeTimeout = useRef<NodeJS.Timeout | null>(null);

  const clearCloseTimeout = useCallback(() => {
    if (closeTimeout.current) {
      clearTimeout(closeTimeout.current);
    }
  }, []);

  const handleMouseEnter = useCallback(() => {
    clearCloseTimeout();
    setIsOpen(true);
  }, [clearCloseTimeout]);

  const handleMouseLeave = useCallback(() => {
    clearCloseTimeout();
    closeTimeout.current = setTimeout(() => {
      setIsOpen(false);
    }, closeDelay);
  }, [clearCloseTimeout, closeDelay]);

  const toggleDropdown = useCallback(() => {
    clearCloseTimeout();
    setIsOpen(!isOpen);
  }, [clearCloseTimeout, isOpen]);

  useClickOutside(ref, () => setIsOpen(false));

  return {
    isOpen,
    ref,
    handleMouseEnter,
    handleMouseLeave,
    toggleDropdown,
  };
};
